import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { ArrowUpRight } from 'lucide-react';

export default function WatchCard({ watch, index = 0 }) {
  const { t } = useI18n();
  const delay = `gn-delay-${Math.min(index + 1, 4)}`;
  const onRequest = watch.availability === 'on_request';
  return (
    <Link
      to={`/watch/${watch.id}`}
      className={`gn-card group block gn-reveal ${delay}`}
      data-testid={`watch-card-${watch.id}`}
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#05150f] relative">
        {watch.images && watch.images[0] ? (
          <img
            src={watch.images[0]}
            alt={`${watch.brand} ${watch.model}`}
            className="w-full h-full object-cover gn-img-hover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#c9a961]/40 font-serif text-3xl">GN</div>
        )}
        {watch.sold && (
          <div className="absolute top-4 left-4 bg-[#08231a]/90 border border-[#c9a961]/40 px-3 py-1 text-[10px] tracking-[0.25em] uppercase text-[#c9a961]">
            {t('watch.sold')}
          </div>
        )}
        {onRequest && !watch.sold && (
          <div className="absolute top-4 left-4 bg-[#08231a]/90 border border-[#c9a961]/40 px-3 py-1 text-[10px] tracking-[0.25em] uppercase text-[#c9a961]" data-testid={`badge-on-request-${watch.id}`}>
            {t('catalog.tab_on_request')}
          </div>
        )}
        <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="bg-[#c9a961] text-[#05150f] p-2"><ArrowUpRight size={16} /></div>
        </div>
      </div>
      <div className="p-6 border-t border-[#c9a961]/15">
        <p className="gn-overline mb-2">{watch.brand}</p>
        <h3 className="font-serif text-xl text-[#f5f5f0] leading-tight mb-1">{watch.model}</h3>
        <p className="text-xs text-[#a3b5ad] tracking-wider mb-4">
          {watch.reference}{watch.year ? ` · ${watch.year}` : ''}
        </p>
        <div className="flex items-baseline justify-between">
          {onRequest ? (
            <span className="font-serif italic text-lg text-[#c9a961]">{t('watch.price_on_request')}</span>
          ) : (
            <span className="font-serif text-2xl text-[#c9a961]">
              {new Intl.NumberFormat('it-CH', { style: 'currency', currency: watch.currency || 'EUR', maximumFractionDigits: 0 }).format(watch.price)}
            </span>
          )}
          <span className="text-[10px] tracking-[0.25em] uppercase text-[#a3b5ad] group-hover:text-[#c9a961] transition-colors">
            {t('catalog.view_details')} →
          </span>
        </div>
      </div>
    </Link>
  );
}
